import {EntityData, field} from "@fedeltapointofsale/data-client";

export class PointsData extends EntityData<PointsData> {
    public static readonly TYPE_NONE = -1;
    public static readonly TYPE_PER_UNIT_AT_ANY_PRICE = 0;
    public static readonly TYPE_PER_DOLLAR = 1;
    public static readonly TYPE_PER_UNIT_AT_FULL_PRICE = 2;
    public static readonly TYPE_PER_UNIT_UNLESS_FREE = 3;
    public static readonly TYPE_PER_UNIT_PRO_RATA = 4;

    @field type: number;
    @field value: number;
}
